module.exports = __webpack_public_path__ + "static/media/fri_mon_digital.4a83d555.png";